import React from 'react';
import './App.css';


function Redirect() {
  // if (isFacebookApp()) {
  //   console.log('redirect')
  // window.location.href = "intent://playfora-dev.firebaseapp.com/#Intent;scheme=https;package=com.playfora.app;end";
  // }

  return (
    <React.Fragment>
      <div style={{ textAlign: 'center', marginTop: '8%' }}>
        Please open the link in your mobile to join the campaign!
      </div>
    </React.Fragment>
  );
}

function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  console.log('ua', ua)
  console.log('navigator', document)
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

export default Redirect;
